jQuery(function ($) {
  // ここに書く。$が利用できる。

  // スムーズスクロール

  // 通常のクリック時
  $('a[href*="#"]').on("click", function () {
    var href = $(this).attr("href")
    if (href == "#top") {// gotopの処理
      scrollToAnker("body", 0)
      return false
    }
    href = "#" + href.split("#")[1]
    scrollToAnker(href, 800)
  })

  // 関数：スムーススクロール
  function scrollToAnker(href, adjust, speed) {
    if (href !== "#") {
      var target = $(href === "" || href == "#top" ? "html" : href);
      var position = target.offset().top
      $("html, body").stop().animate({ scrollTop: position }, speed, "swing")
    }
    return false
  }
  // スムーズスクロールここまで

  // スマホメニュー設定
  var navs = $("header, .gnav-on")
  $(".gnav-toggle").on("click", function () {
    $(".gnav-on li").toggleClass("is-closed")
    navs.toggleClass("is-opened")
    $(".gnav-on li").toggleClass("is-opened")
  })
  $(".gnav-on a").on("click", function(){
    navs.removeClass("is-opened")
    $(".gnav-on li").removeClass("is-opened")
  })

  // スクロールでロゴ出る
  var header = $("header")
  var slider = $(".slider")
  $(window).on('load scroll resize', function () {
    var nowTop = $(this).scrollTop()
    // console.log("now:"+nowTop+"pm:"+pmTop)
    if (nowTop > 250) {
      header.removeClass("is-top");
    } else {
      var uri = location.pathname;
      if (uri.match(/whats-new/)) {
        header.removeClass("is-top");
      } else {
        header.addClass('is-top')
      }
    }
  })


  // AOS.init
  AOS.init()
  
  // slick設定
  slider.slick({
    infinite: false,
    variableWidth: true,
    slidesToShow: 2,
    prevArrow:
      '<div class="btn-prev"><img src="/wp-content/themes/fact-theme/img/btn-prev-arrow.svg"></div>',
    nextArrow:
      '<div class="btn-next"><img src="/wp-content/themes/fact-theme/img/btn-next-arrow.svg"></div>'
  });
  function scrollResize() {
    if ($(window).width() < 885) {
      $(".page-work .slider .slick-arrow.btn-next").css("left", $(window).width() -55 + "px");
    }else{
      $(".page-work .slider .slick-arrow.btn-next").css("left", "885px");
    }
  }
  $(window).resize(function() {
    scrollResize();
  });
  scrollResize();
  
  $('.news-list-wrapper').infinitescroll({
    loading: {
      finishedMsg: "<div class='list-finished-message'>none</div>", //最後まで到達した時のメッセージ
      msgText: "<div class='list-load-message'>loading ...</div>" //ロード中のメッセージ
    },
    navSelector : ".archives-nav",
    nextSelector : ".archives-nav a.next",
    itemSelector : ".news-list"
  }, function() {
    $.when(
      slider.slick('unslick')
    ).done(function(){
      slider = $(".slider");
      slider.slick({
        infinite: !1,
        variableWidth: !0,
        slidesToShow: 2,
        prevArrow: '<div class="btn-prev"><img src="/wp-content/themes/fact-theme/img/btn-prev-arrow.svg"></div>',
        nextArrow: '<div class="btn-next"><img src="/wp-content/themes/fact-theme/img/btn-next-arrow.svg"></div>'});
    });
    scrollResize();
  });
})
